/* istanbul ignore file */
import { useContext } from 'react';

import { personalBeautyStoreContext } from './personalBeautyStoreContext';

export const usePersonalBeautyStore = () => useContext(personalBeautyStoreContext);
